import {
  createFilterFormStore,
  usePersistedFilterFormik,
} from "../../../util/usePersistedFilterFormik";
import { convertToFilter, makeObservable } from "../../../util";
import { useEffect } from "react";
import * as Yup from "yup";
import { createSearchResultNavigationStore } from "../../../util/searchResultNavigation";

const exhibitionFilterStore = makeObservable({});
const exhibitionNavigationStore = createSearchResultNavigationStore(
  exhibitionFilterStore,
);

const toExhibitionFilter = values =>
  convertToFilter({ values, filterKeys: [], skipKeys: ["limit", "offset"] });

const filterFormStore = createFilterFormStore(
  "exhibition",
  exhibitionFilterStore,
  exhibitionNavigationStore,
  { toFilter: toExhibitionFilter },
);

const useExhibitionFilters = () => {
  const formik = usePersistedFilterFormik(
    {
      initialValues: {
        limit: 50,
        type: { operator: "in" },
      },
      validationSchema: Yup.object({
        startDay: Yup.number()
          .min(1, "Start Day must be at least 1")
          .max(31, "Start Day must be 31 at most")
          .nullable(),
        startYear: Yup.number()
          .min(1900, "Start Year must be at least 1900")
          .max(2099, "Start Year must be at least 2099")
          .nullable(),
        endDay: Yup.number()
          .min(1, "Start Day must be at least 1")
          .max(31, "Start Day must be 31 at most")
          .nullable(),
        endYear: Yup.number()
          .min(1900, "End Year must be at least 1900")
          .max(2099, "End Year must be at least 2099")
          .nullable(),
      }),
    },
    filterFormStore,
  );

  useEffect(() => {
    exhibitionFilterStore.set(toExhibitionFilter(formik.values));
  }, [formik.values]);

  return {
    formik,
  };
};

export {
  exhibitionFilterStore,
  exhibitionNavigationStore,
  useExhibitionFilters,
};
